import React from 'react';
import './CoverageAreas.css';

const CoverageAreas = () => {
  const areas = [
    'Santa Ana',
    'Portoviejo',
    'Calderón',
    '24 de Mayo'
  ];

  return (
    <div className="container">
      <div className="row">
        <div className="col">
          <h2 className="coverage-title">Áreas de Cobertura</h2>
          <ul className="coverage-areas">
            {areas.map((area, index) => (
              <li key={index} className="coverage-area">
                {area}
              </li>
            ))}
          </ul>
        </div>
        <div className="col">
          <div className="map-container">
            <img
              src="/images/misc/Mapa.png?height=400&width=500"
              alt="Mapa de cobertura"
              className="map-image"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoverageAreas;

